"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CountryCodeValidationPlugin_1 = __importDefault(require("./plugins/CountryCodeValidationPlugin"));
var DateValidationPlugin_1 = __importDefault(require("./plugins/DateValidationPlugin"));
var EmailValidationPlugin_1 = __importDefault(require("./plugins/EmailValidationPlugin"));
var FileValidationPlugin_1 = __importDefault(require("./plugins/FileValidationPlugin"));
var NumberValidationPlugin_1 = __importDefault(require("./plugins/NumberValidationPlugin"));
var PatternValidationPlugin_1 = __importDefault(require("./plugins/PatternValidationPlugin"));
var RequiredValidationPlugin_1 = __importDefault(require("./plugins/RequiredValidationPlugin"));
var SubjectValidationPlugin_1 = __importDefault(require("./plugins/SubjectValidationPlugin"));
var TelephoneNumberValidationPlugin_1 = __importDefault(require("./plugins/TelephoneNumberValidationPlugin"));
var CatchAllValidationPlugin_1 = __importDefault(require("./plugins/CatchAllValidationPlugin"));
console.debug('INFO FieldValidator.ts loaded');
/**
 * @class
 */
var FieldValidator = /** @class */ (function () {
    function FieldValidator(field) {
        this.field = field;
        this.validationPlugins = [];
        this._processRequired();
        this._processNumber();
        this._processPattern();
        this._processFileUpload();
        this._processDate();
        this._processEmail();
        this._processSubject();
        this._processTelephoneNumber();
        // catch all validator: has to be last!
        if (this.field.getAttribute('type') !== 'checkbox') {
            this._addCatchAll();
        }
    }
    FieldValidator.prototype.runCustomValidations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, plugin;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.validationPlugins;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        plugin = _a[_i];
                        // plugin.runCustomValidation may be sync (boolean) or async (Promise<boolean>)
                        return [4 /*yield*/, plugin.runCustomValidation()];
                    case 2:
                        // plugin.runCustomValidation may be sync (boolean) or async (Promise<boolean>)
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FieldValidator.prototype.getMessages = function () {
        var messages = [];
        for (var _i = 0, _a = this.validationPlugins; _i < _a.length; _i++) {
            var plugin = _a[_i];
            if (!plugin.isValid()) {
                messages.push(plugin.getMessage());
            }
        }
        return messages;
    };
    FieldValidator.prototype._addValidationPlugin = function (plugin) {
        if (plugin) {
            this.validationPlugins.push(plugin);
        }
    };
    FieldValidator.prototype._processRequired = function () {
        if (this.field.hasAttribute('required')) {
            this._addValidationPlugin(new RequiredValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processNumber = function () {
        if (this.field.getAttribute('type') === 'number') {
            this._addValidationPlugin(new NumberValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processDate = function () {
        if (this.field.hasAttribute('date')) {
            this._addValidationPlugin(new DateValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processEmail = function () {
        if (this.field.getAttribute('name') === 'email') {
            this._addValidationPlugin(new EmailValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processPattern = function () {
        if (this.field.hasAttribute('pattern')) {
            this._addValidationPlugin(new PatternValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processFileUpload = function () {
        if (this.field.getAttribute('type') === 'file') {
            this._addValidationPlugin(new FileValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._addCatchAll = function () {
        this._addValidationPlugin(new CatchAllValidationPlugin_1.default(this.field));
    };
    FieldValidator.prototype._processSubject = function () {
        if (this.field.getAttribute('id') === 'select-subject') {
            this._addValidationPlugin(new SubjectValidationPlugin_1.default(this.field));
        }
    };
    FieldValidator.prototype._processTelephoneNumber = function () {
        if (this.field.getAttribute('name') === 'telephonenumber') {
            var countryCodeField = document.querySelector('select[name="telephonenumber_countryCode"]');
            this._addValidationPlugin(new TelephoneNumberValidationPlugin_1.default(this.field, countryCodeField));
        }
        else if (this.field.getAttribute('name') === 'mobilenumber') {
            var countryCodeField = document.querySelector('select[name="mobilenumber_countryCode"]');
            this._addValidationPlugin(new TelephoneNumberValidationPlugin_1.default(this.field, countryCodeField));
        }
        else if (this.field.getAttribute('name') === 'telephonenumber_countryCode') {
            var telephoneNumberField = document.querySelector('input[name="telephonenumber"]');
            this._addValidationPlugin(new CountryCodeValidationPlugin_1.default(this.field, telephoneNumberField));
        }
        else if (this.field.getAttribute('name') === 'mobilenumber_countryCode') {
            var telephoneNumberField = document.querySelector('input[name="mobilenumber"]');
            this._addValidationPlugin(new CountryCodeValidationPlugin_1.default(this.field, telephoneNumberField));
        }
    };
    return FieldValidator;
}());
exports.default = FieldValidator;
